<template>
  <component
    :is="component"
    v-bind="tabAttrs"
    data-testid="tab-item"
    class="tab relative border-b-2 border-s-400 p-2 text-base font-semibold"
    :class="[isActive ? 'active-tab text-s-900' : 'text-[#a3a5ae]']"
    no-prefetch
  >
    {{ buttonText }}
  </component>
</template>

<script setup lang="ts">
import { resolveComponent } from 'vue'

const props = defineProps<{
  text: string
  mobileText?: string
  isActive: boolean
  url?: string
}>()

const buttonText = ref(props.text)

const hasUrl = computed(() => props.url !== '')
const component = computed(() =>
  hasUrl.value ? resolveComponent('NuxtLink') : 'button',
)
const tabAttrs = computed(() => (hasUrl.value ? { to: props.url } : {}))

const initializeButtonTextChanger = () => {
  if (!props.mobileText) return
  const mql = window.matchMedia('(max-width: 1024px)')
  if (mql.matches) {
    buttonText.value = props.mobileText
  }
  mql.onchange = (e) => {
    if (e.matches) {
      buttonText.value = props.mobileText
    } else {
      buttonText.value = props.text
    }
  }
}

onMounted(() => {
  if (typeof window === 'undefined') return
  initializeButtonTextChanger()
})
</script>

<style scoped>
.tab::after {
  display: block;
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  background: theme('colors.p.500');
  height: 4px;
  width: 100%;
  transform: scaleX(0);
  transition: transform 150ms ease-in-out;
}

.tab.active-tab::after {
  transform: scaleX(1);
}
</style>
